import "./home.scss";

import { useCallback, useEffect, useState } from "react";

import { API_URL } from "../../utils/constants";
import AlertMessage from "../lessons/trial/AlertMessage";
import BalanceCard from "./balance-card/BalanceCard";
import Card from "./card/Card";
import Layout from "../layout/Portal";
import axios from "axios"; // For making API requests
import { fetchBalance } from "../../features/Dashboard";
import { isError } from "cypress/types/lodash";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query"; // Import useQuery
import { useTrialLesson } from "../../context/TrailLessonContext";

export const Home = () => {
  const { isTrialLessonCreated } = useTrialLesson();
  const getRole = () => {
    return localStorage.getItem("Role");
  };

  console.log(getRole());
  const balance = 0; // Example balance
  const completedClasses = 0;

  const navigate = useNavigate();

  const handleWithdraw = () => {
    navigate("./withdraw"); // You can replace this with real withdrawal logic, e.g., open a modal or redirect.
  };

  const [values, updateValues] = useState({
    data: "",
    loading: false,
    error: "",
  });

  const {
    data: balanceData,
    isLoading: isBalanceLoading,
    error: balanceError,
  } = useQuery({
    queryKey: ["balance"],
    queryFn: fetchBalance,
  });

  // Function to fetch the teacher
  const fetchUpcommingLesson = async () => {
    const token = localStorage.getItem("token"); // Replace with your token retrieval method

    const response = await axios.get(
      `${API_URL}/bookings/merchants/count?completed=false`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data.result.count;
  };

  //this endpoint is always returning 0
  const {
    data: sessionCount,
    isLoading: isSessionLoading,
    isError: isSessionError,
    error: sessionError,
  } = useQuery({
    queryKey: ["bookedSessionsCount"],
    queryFn: fetchUpcommingLesson,
  });

  useEffect(() => {
    if (balanceError) {
      toast.error(
        balanceError?.message ||
          "Error loading balance. Please try reloading your page.",
        {
          richColors: true,
        },
      );
    }
  }, [balanceError]);
  useEffect(() => {
    if (sessionError) {
      toast.error(
        sessionError?.message || "something went wrong Please relaod",
        {
          richColors: true,
        },
      );
    }
  }, [sessionError]);

  return (
    <Layout color="transparent">
      {/* Global warning */}
      <div className="" style={{ marginBottom: "2rem" }}>
        {!isTrialLessonCreated && <AlertMessage title="Action Required" />}
      </div>

      <div className="dashBox">
        <h2>Welcome to your Dashboard</h2>

        {/* Container for the cards */}
        <div className="dashboard-cards">
          {/* Display the balance card */}
          <BalanceCard
            isLoading={isBalanceLoading}
            balance={parseInt(balanceError ? "0" : balanceData)}
            onWithdraw={handleWithdraw}
            balanceError={balanceError}
          />

          {/* Display the transactions card */}
          <Card
            totalTransactions={sessionCount}
            isLoading={isSessionLoading}
            onClick={() => {
              navigate("/schedule");
            }}
          />
        </div>
      </div>
    </Layout>
  );
};
